// OSG header: open dropdowns on hover (desktop), close other dropdowns,
// and close menus on outside click or Escape.
(function () {
  const desktop = window.matchMedia('(min-width: 1100px) and (hover: hover)');

  function init(header) {
    const dropdowns = header.querySelectorAll('[data-osg-dropdown]');
    const mobile = header.querySelector('[data-osg-mobile]');

    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('toggle', () => {
        if (!dropdown.open) return;
        dropdowns.forEach((other) => {
          if (other !== dropdown) other.removeAttribute('open');
        });
      });

      let closeTimer;
      dropdown.addEventListener('mouseenter', () => {
        if (!desktop.matches) return;
        clearTimeout(closeTimer);
        dropdown.setAttribute('open', '');
      });
      dropdown.addEventListener('mouseleave', () => {
        if (!desktop.matches) return;
        closeTimer = setTimeout(() => dropdown.removeAttribute('open'), 150);
      });
    });

    document.addEventListener('click', (event) => {
      if (header.contains(event.target)) return;
      dropdowns.forEach((dropdown) => dropdown.removeAttribute('open'));
      if (mobile) mobile.removeAttribute('open');
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      dropdowns.forEach((dropdown) => dropdown.removeAttribute('open'));
      if (mobile) mobile.removeAttribute('open');
    });
  }

  function initAll() {
    document.querySelectorAll('[data-osg-header]').forEach((header) => {
      if (header.dataset.osgReady) return;
      header.dataset.osgReady = 'true';
      init(header);
    });
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
